var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWeatherVolcano(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.25 12.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #667085;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m.75,12s2.98-4.94,3.19-6.47v-1.14h6.13v1c0,1.5,3.43,6.63,3.43,6.63l-12.75-.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.69,
    y1: 1.16,
    x2: 7.69,
    y2: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.69,
    y1: 2.55,
    x2: 7.69,
    y2: 2.55
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.52,
    y1: 1.16,
    x2: 4.52,
    y2: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.52,
    y1: 2.55,
    x2: 4.52,
    y2: 2.55
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.11,
    y1: 1.89,
    x2: 6.11,
    y2: 2.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.11,
    y1: 0.5,
    x2: 6.11,
    y2: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.27,
    y1: 1.89,
    x2: 9.27,
    y2: 2.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.27,
    y1: 0.5,
    x2: 9.27,
    y2: 0.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherVolcano);
export default __webpack_public_path__ + "static/media/icon_weather_volcano.346cb6d241ab41cb223e296f7f940bec.svg";
export { ForwardRef as ReactComponent };